export default {
  /**
   * 入力値が半角英数字記号かをチェックする
   * @param {*} value
   * @param {*} size
   * @returns
   */
  isAlphaNumericSymbol: function (value) {
    return new RegExp(/^[a-zA-Z0-9!-/:-@¥[-`{-~]*$/).test(value);
  },
  /**
   * 入力値が日付形式かをチェックする
   * @param {*} value
   * @param {*} size
   * @returns
   */
  isDateFormat: function (value) {
    if (value === null) return true;
    let date = new Date(value);
    return !isNaN(date.getDate());
  },
  /**
   * 入力値が半角英数字記号かをチェックする
   * @param {*} value
   * @param {*} size
   * @returns
   */
  isEmail: function (value) {
    if (typeof value !== 'string' || value !== value.trim()) return false;
    return new RegExp(/^[A-Za-z0-9]{1}[A-Za-z0-9+_.-]*@{1}[A-Za-z0-9_.-]+\.[A-Za-z0-9]+$/).test(
      value
    );
  },
  /**
   * 入力値がNULLまたは空文字でないかをチェックする
   * @param {*} value
   * @returns
   */
  isNullOrEmpty: function (value) {
    if (value === null) return true;
    if (value === '') return true;
    return false;
  },
  /**
   * 入力値が半角数字のみかをチェックする
   * @param {*} value
   * @param {*} size
   * @returns
   */
  isNumeric: function (value) {
    return new RegExp(/^[0-9]*$/).test(value);
  },
  /**
   * 入力値が半角数字とハイフンのみかをチェックする
   * @param {*} value
   * @param {*} size
   * @returns
   */
  isNumericHyphen: function (value) {
    return new RegExp(/^[0-9\-]*$/).test(value);
  },
  /**
   * 入力値が半角数字とピリオドのみかをチェックする
   * @param {*} value
   * @param {*} size
   * @returns
   */
  isNumericPeriod: function (value) {
    return new RegExp(/^[0-9\.]*$/).test(value);
  },
  /**
   * 入力値が制限サイズを超えていないかをチェックする
   * @param {*} value
   * @param {*} size
   * @returns
   */
  isOverFlow: function (value, size) {
    // console.debug(`isOverFlow: ${value} size: ${size}`);
    if (value === null) return false;
    if (value === undefined) return false;
    if (value.toString().length > size) return true;
    return false;
  },
  /**
   * 文字列を検証する
   * @param {*} param0
   * @returns
   */
  validateChars: function ({
    value,
    size,
    requiredCheck,
    alphaNumericSymbocCheck,
    numerickCheck,
    numericHyphenCheck,
    emailCheck,
  }) {
    //console.log({ value, size, requiredCheck, alphaNumericSymbocCheck });

    if (requiredCheck && this.isNullOrEmpty(value)) {
      return '必須項目です';
    }

    // 空文字の場合以降のチェックを行わない
    if (this.isNullOrEmpty(value)) return null;

    if (alphaNumericSymbocCheck && !this.isAlphaNumericSymbol(value)) {
      return '半角英数字記号で入力してください';
    }

    if (numerickCheck && !this.isNumeric(value)) {
      return '半角数字で入力してください';
    }

    if (numericHyphenCheck && !this.isNumericHyphen(value)) {
      return '半角数字とハイフンで入力してください';
    }

    if (emailCheck && !this.isEmail(value)) {
      return 'メールアドレスの形式で入力してください';
    }

    if (this.isOverFlow(value, size)) {
      return size + '文字以内で入力してください';
    }

    return null;
  },
  /**
   * 日付を検証する
   * @param {*} param0
   * @returns
   */
  validateDate: function ({ value, requiredCheck }) {
    if (!value) {
      if (requiredCheck) {
        return '必須項目です';
      } else {
        return null;
      }
    }

    let dateChars = `${value.year}${value.month}${value.day}`.trim();

    if (dateChars === '') {
      if (requiredCheck) {
        return '必須項目です';
      } else {
        return null;
      }
    }

    dateChars = `${value.year}-${value.month}-${value.day}`;

    if (requiredCheck && dateChars.length !== 10) {
      return '必須項目です';
    }

    if (!this.isDateFormat(dateChars)) {
      return '日付形式ではありません';
    }

    return null;
  },
  /**
   * 入力した年月日が現在日より未来かを検証する
   * @param {*} param0
   * @returns
   */
  validateFutureDate: function ({ value }) {
    let dateChars = `${value.year}/${value.month}/${value.day}`;
    const currentDate = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate(),
      0,
      0,
      0
    );

    if (this.isDateFormat(dateChars)) {
      const inputDate = new Date(dateChars);
      if (inputDate < currentDate) {
        return '本日より未来の日付を入力してください';
      }
    }

    return null;
  },
  /**
   * 小数値を検証する
   * @param {*} param0
   * @returns
   */
  validateDecimal: function ({ value, precision, scale, requiredCheck }) {
    if (requiredCheck && this.isNullOrEmpty(value)) {
      return '必須項目です';
    }

    // 空文字の場合以降のチェックを行わない
    if (this.isNullOrEmpty(value)) return null;

    if (!this.isNumericPeriod(value)) {
      return '数字とピリオドで入力してください';
    }

    let array = value.split('.');
    if (array.length > 2) {
      return 'ピリオド(.)は１つ以内で入力してください';
    }
    //console.log(array);
    switch (array.length) {
      case 1:
        if (array[0].toString().length > precision) {
          return '整数部分：' + precision + '桁、小数部分：' + scale + '桁で入力してください';
        }
        break;
      case 2:
        if (array[0].toString().length > precision || array[1].toString().length > scale) {
          return '整数部分：' + precision + '桁、小数部分：' + scale + '桁で入力してください';
        }
        break;
      default:
        return 'ピリオド(.)は１つ以内で入力してください';
    }

    return null;
  },
};
